/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

/**
 * Payload de `PUT /acte-adresses/{id}` : un lieu d'acte (`ec_acte_adresse`).
 *
 * ⚠️ Les noms sont ceux du `$serializable` d'`ActeAdresse`, PAS les alias de
 * confort que le front produit (`libelleCommune`, `libelleCodePostal`…). Le
 * repository de numérisation les traduit à la création
 * (`NumeriseActe::traduireAliasLieu`), mais un PUT direct passe par le
 * `Repository` du framework, dont `cleanFields()` élague en silence toute clé
 * qu'il ne connaît pas — la commune serait perdue sans erreur.
 *
 * @param adresse Lieu à la forme de `ChampLieu` / `NaissanceForm`.
 */
const buildLieuActeUpdatePayload = (adresse: Record<string, any> | undefined) =>
  _.omitBy(
    {
      localite: adresse?.libelleCommune,
      codePostal: adresse?.libelleCodePostal,
      codeDepartement: adresse?.codeDepartement,
      libelleDepartement: adresse?.libelleDepartement,
      libellePays: adresse?.libellePays,
      codeInsee: adresse?.codeInsee,
      identifiantCommune: adresse?.identifiantCommune,
      identifiantDepartement: adresse?.identifiantDepartement,
      identifiantPays: adresse?.identifiantPays,
    },
    _.isNil,
  );

export default buildLieuActeUpdatePayload;
